import { IStop } from 'apps/fleet-planner/types/loads'
import { STOP_TYPE } from '../constants/loads'

export const stopTypeLength = (stopType: STOP_TYPE, stops: IStop[]) =>
  stops.filter(stop => stop.stopType === stopType).length

const stopNumber = (stop: IStop, pickupLength: number, dropoffLength: number): number => {
  if (stop.stopType === STOP_TYPE.pickup && pickupLength > 1) {
    return stop.stopSequence
  }
  if (stop.stopType === STOP_TYPE.dropoff && dropoffLength > 1) {
    return stop.stopSequence - pickupLength
  }
  return 0
}

export const getStopNumbers = (stops: IStop[]) => {
  const pickupLength = stopTypeLength(STOP_TYPE.pickup, stops)
  const dropoffLength = stopTypeLength(STOP_TYPE.dropoff, stops)
  return stops.map(stop => stopNumber(stop, pickupLength, dropoffLength))
}
